import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import {BeatLoader} from "react-spinners";
import loadingGif from "../../assets/img/loading.gif";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {confirmAlert} from 'react-confirm-alert';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import AmountNotationFilter from '../../filters/AmountNotationFilter.jsx';
import MetricFilter from '../../filters/MetricFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config, lastTenMonthsColumn, numDifferentiation, formatNumber, user_activities } from '../../helpers/utils.js';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var timestamp  = new Date().getTime();
var date_config = date_range_config('1', '0', '2020-02-01','1');

class GooglePayMonthlySalesReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            cityIds:'',
            loading:false,
            metric: 'volume',
            loadingtable: true,
            is_record: true,
            is_export: false,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_export2: false,
            store_level_chain_code:'',
            tenderModeIDs:'',
            is_store_loading: true,
            isChange: false,
            object_code:[],
            amount_type: 'Thousand',
            fetch_data:false
        }

    }
    componentDidUpdate() {

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'monthly_sales');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidMount() {
        this.get_filtered_dcc_sales_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'google_pay_monthly_sales_report','sparcs')
    }


    get_filtered_dcc_sales_report(object_type, object_code, event) {
        let windowSize = $(window).width();
        let mcol = "15%";
        let othcol = "7%";
        let autoWidth = true;
        let scrollx = true;
        if (windowSize > 1700) {
            mcol = "15%";
            othcol = "7%";
            autoWidth = false;
            scrollx = false;
        }
        if ($.fn.DataTable.isDataTable('#GpayMonthlySalesReportsCat')) {
            $('#GpayMonthlySalesReportsCat').DataTable().clear().destroy();
        }
        $('#GpayMonthlySalesReportsCat').html('');
        if ($.fn.DataTable.isDataTable('#GpayMonthlySalesReportsCatStore')) {
            $('#GpayMonthlySalesReportsCatStore').DataTable().clear().destroy();
        }
        $('#GpayMonthlySalesReportsCatStore').html('');
        this.setState({
            loadingtable: true,
            is_record: true,
            is_export: false,
            is_export2: false
        });
        let tableHeaders = [];
        let tableBody = [];
        let tableHeaders1 = [];
        let tableBody1 = [];
        let lastTenMonths = lastTenMonthsColumn();

        if (Array.isArray(lastTenMonths) && lastTenMonths.length) {


            tableHeaders.push(
                {
                    sTitle: 'Merchant',
                    mData: 'Merchant',
                    // className: 'details-control',
                    "width": mcol,
                    className: ""
                },
                {
                    sTitle: 'Chain',
                    mData: 'Merchant Code',
                    "width": mcol,
                    className: ""
                });
            tableBody.push({data: 'Merchant'}, {data: 'Merchant Code'},);
            lastTenMonths.forEach(function (k) {
                tableHeaders.push({
                    sTitle: k,
                    mData: k.replace(/\./g, '\\.'),
                    "width": othcol,
                    className: "text-right"
                });
                tableBody.push({
                    data: k,
                })
            });


            //console.log(shortedDate1);
            tableHeaders1.push(
                {
                    sTitle: 'Store',
                    mData: 'Store',
                    // className: 'details-control',
                    "width": mcol,
                    className: ""
                },
                {
                    sTitle: 'UTID',
                    mData: 'Store Code',
                    "width": mcol,
                    className: ""
                });
            tableBody1.push({data: 'Store'}, {data: 'Store Code'},);
            lastTenMonths.forEach(function (k) {
                tableHeaders1.push({
                    sTitle: k,
                    mData: k.replace(/\./g, '\\.'),
                    "width": othcol,
                    className: "text-right"
                });
                tableBody1.push({
                    data: k,
                })
            });
            this.setState({
                loadingtable: false,
                is_record: true,
                is_export: true
            });
            this.get_filtered_dcc_sales_report_data(object_type, object_code, event, tableHeaders, tableBody, tableHeaders1, tableBody1, autoWidth, scrollx);
        } else {
            //alert("hi");
            if ($.fn.DataTable.isDataTable('#GpayMonthlySalesReportsCat')) {
                $('#GpayMonthlySalesReportsCat').DataTable().clear().destroy();
            }

            this.setState({
                is_record: false,
                loadingtable: false,
            });
        }

    }

    get_filtered_dcc_sales_report_data(object_type, object_code, event, tableHeaders, tableBody, tableHeaders1, tableBody1, autoWidth, scrollx) {
        var that = this;
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
            this.setState({
                merchantID:object_code
            })
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
            this.setState({
                chainID:object_code
            })
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
            this.setState({
                storeID:object_code
            })
        }
        isApiResponse(false);
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            tender_mode: that.state.tenderModeIDs,
            weekly_or_monthly: 'monthly',
            txn_type: 'GOOGLE_PAY'
        };
        var GpayMonthlySalesReportsCatTable = $('#GpayMonthlySalesReportsCat').DataTable(
            {
                order: [],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo": false,
                "sPaginationType": "numbers",
                // "autoWidth": autoWidth,
                "responsive": false,
                // "scrollX": scrollx,
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url: config.get('API_URL') + "/reports/monthly-sales-reports-category",
                    type: "POST",
                    data: postData,
                    dataSrc: function (json) {
                        //console.log(json);
                        isApiResponse(true);
                        return json.data;
                    },
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },
                aoColumns: tableHeaders,
                columns: tableBody,
                "columnDefs": [
                    {
                        render: function (data) {
                            return '<td ><div class="collapseFirstTD"><a href="#">' + data + '</a> </div></td>';
                        },
                        className: "summary_plus clickable",
                        targets: 0,
                        aTargets: [-1]
                    },
                    {
                        render: function (data) {
                            return '<td >&nbsp;</td>';
                        },
                        targets: 1,
                        aTargets: [-1]
                    },
                    {
                        render: function (data) {
                            return '<td >' + numDifferentiation(data,that.state.amount_type) + '</td>';
                        },
                        "targets": [2, 3, 4, 5, 6]
                    },
                ],
            });

        $('#GpayMonthlySalesReportsCat').on('click', 'td.clickable', function (e) {
            e.preventDefault();
            var tr = $(this).closest('tr');
            var row = GpayMonthlySalesReportsCatTable.row(tr);
            if (row.child.isShown()) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            } else {
                // Open this row
                if (row.data() != undefined) {
                    isApiResponse(false);
                    var mcode = row.data()["Merchant Code"];
                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    row.child(loadingImg).show();
                    var chainData1 = {
                        mcode: mcode,
                        cids: chains,
                        sids: stores,
                        bids: that.state.acqBankIds,
                        cityids: that.state.cityIds,
                        from: that.state.yestSend,
                        to: that.state.todSend,
                        metric: that.state.metric,
                        tender_mode: that.state.tenderModeIDs,
                        weekly_or_monthly: 'monthly',
                        txn_type: 'GOOGLE_PAY'
                    }
                    var ttype = 'monthly';
                    $.ajax({
                        type: 'POST',
                        data: chainData1,
                        url: config.get('API_URL') + "/reports/monthly-sales-reports-details-category",
                        beforeSend: function (request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            //console.log(data);
                            content = '<table id="innerTable" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                tableHeaders.map((val, index) => {
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation(value[val.sTitle],that.state.amount_type);
                                    if (val.sTitle == 'Chain') {
                                        ClickableTd = '<a href="#" data-chain="' + value["Chain Code"] + '">' + value[val.sTitle] + '</a>';
                                    }
                                    content = content + '<td class="chain_level ' + val.className + '"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content, 'no-padding').show();
                            tr.addClass('shown');
                            isApiResponse(true);
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
        var GpayMonthlySalesReportsCatStoreTable = '';
        var chainCode = '';
        $('#GpayMonthlySalesReportsCat').on('click', 'td.chain_level a', function (e) {
            e.stopImmediatePropagation();
            chainCode = $(this).data("chain");
            isApiResponse(false);
            var postData1 = {
                chain_code: chainCode,
                metric: that.state.metric,
                weekly_or_monthly: 'monthly',
                tender_mode: that.state.tenderModeIDs,
                sids: that.state.storeID,
                mids: merchants,
                bids: that.state.acqBankIds,
                cityids: that.state.cityIds,
                from: that.state.yestSend,
                to: that.state.todSend,
                txn_type: 'GOOGLE_PAY'
            };
            GpayMonthlySalesReportsCatStoreTable = $('#GpayMonthlySalesReportsCatStore').DataTable(
                {
                    order: [],
                    //"dom": 'fltip',
                    "processing": true,
                    "serverSide": true,
                    "bDestroy": true,
                    "paging": true,
                    "pageLength": 20,
                    "bInfo": false,
                    "sPaginationType": "numbers",
                    // "autoWidth": autoWidth,
                    "responsive": false,
                    // "scrollX": scrollx,
                    "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],

                    ajax: {
                        url: config.get('API_URL') + "/reports/monthly-sales-reports-store-category",
                        type: "POST",
                        data: postData1,
                        dataSrc: function (json) {
                            isApiResponse(true);
                            return json.data;
                        },
                        beforeSend: function (request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        error: function (data) {
                            isApiResponse(true);
                        },
                        complete: function (data) {
                            isApiResponse(true);
                        },
                    },
                    aoColumns: tableHeaders1,
                    columns: tableBody1,
                    "columnDefs": [
                        {
                            render: function (data) {
                                return '<td ><div class="collapseFirstTD"><a href="#">' + data + '</a> </div></td>';
                            },
                            className: "summary_plus clickable",
                            targets: 0,
                            aTargets: [-1]
                        },
                        {
                            render: function (data) {
                                return '<td >&nbsp;</td>';
                            },
                            targets: 1,
                            aTargets: [-1]
                        },
                        {
                            render: function (data) {
                                return '<td >' + numDifferentiation(data,that.state.amount_type) + '</td>';
                            },
                            "targets": [2, 3, 4, 5, 6]
                        },
                    ],
                });
            $('html, body').animate({
                scrollTop: $("#StoreLabel").offset().top
            }, 1000);
            that.setState({
                is_export2: true,
                store_level_chain_code: chainCode
            })

        });
        $('#GpayMonthlySalesReportsCatStore').on('click', 'td.clickable', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            //alert(chainCode);
            var tr = $(this).closest('tr');
            var row = GpayMonthlySalesReportsCatStoreTable.row(tr);
            if (row.child.isShown()) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            } else {
                // Open this row
                if (row.data() != undefined) {
                    isApiResponse(false);
                    var scode = row.data()["Store Code"];
                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    var storeData = {
                        ccode: chainCode,
                        scode: scode,
                        metric: that.state.metric,
                        weekly_or_monthly: 'monthly',
                        tender_mode: that.state.tenderModeIDs,
                        mids: merchants,
                        bids: that.state.acqBankIds,
                        cityids: that.state.cityIds,
                        from: that.state.yestSend,
                        to: that.state.todSend,
                        txn_type: 'GOOGLE_PAY'

                    }
                    row.child(loadingImg).show();
                    $.ajax({
                        type: 'POST',
                        data: storeData,
                        url: config.get('API_URL') + "/reports/monthly-sales-reports-store-details-category",
                        beforeSend: function (request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            //console.log(data);
                            content = '<table id="innerTable" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                tableHeaders1.map((val, index) => {
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation(value[val.sTitle],that.state.amount_type);
                                    if (val.sTitle == 'UTID') {
                                        ClickableTd = value[val.sTitle];
                                    }
                                    content = content + '<td class="chain_level ' + val.className + '"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content, 'no-padding').show();
                            tr.addClass('shown');
                            isApiResponse(true);
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
    }

    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        //this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID, false,'');
        //this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        //this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }

    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }

    handleMetric = (metric) => {
        this.setState({
            metric:metric,
            isChange: true
        });
    }
    handleAmountNotation = (amt) => {
        this.setState({
            amount_type:amt,
            isChange: true
        });
    }
downloadDccSalesMerchantLevelCheck(){

    if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.acqBankIds ==='' && this.state.cityIds ==='' && this.state.tenderModeIDs===''){
      confirmAlert({
            //title: 'Warning',
            message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
            buttons: [{
                label: 'OK',
                onClick: () => {
                    this.downloadDccSalesMerchantLevel();
                }
            },
                {
                    label: 'Cancel',
                }
            ]
        });
        } else {
        this.downloadDccSalesMerchantLevel()
        }
    }
    downloadDccSalesMerchantLevel(type, dw_chain_code, e) {
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            download: true,
            type: type,
            weekly_or_monthly: 'monthly',
            tender_mode: this.state.tenderModeIDs,
            dw_chain_code: dw_chain_code,
            txn_type: 'GOOGLE_PAY',
            category: 'GOOGLE_PAY'
        };

        let xhrBank = $.ajax({
            url: config.get('API_URL') + "/reports/monthly-sales-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyGpMsFile(response.data);
                this.setState({
                    fetch_data:true
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    copyGpMsFile(remotePath){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp + 'google_pay_monthly_sales_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }

    downloadFile(e) { //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }

    closeModal() {
        this.setState({
            model_visible: false
        });
    }

    reset_all(e){
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            //this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            //this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
           // this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            //this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }

        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.metricFilter.resetMetricFilter();
        this.refs.amountNotationFilter.resetAmountNotationFilter();
        this.setState({
            merchantID:'',
            chainID:'',
            storeID:'',
            acqBankIds:'',
            cityIds:'',
            file_url: '',
            rfile: '',
            tenderModeIDs:'',
            metric: 'volume',
            amount_type:'Thousand'
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    render() {

        return (
          
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Google Pay Monthly Sales Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                    {this.state.object_type ==='Innoviti'?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                            <div className="clearfix"></div>
                                        </div> : null}
                                        {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Chain </label>
                                                <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>: null }
                                        {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Store: </label>
                                                <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>: null }

                                        {/*{this.state.acq_bank_list_box===true?*/}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Acquirer:</label>
                                            <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                            <div className="clearfix"></div>
                                        </div>

                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> City: </label>
                                            <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                            <div className="clearfix"></div>
                                        </div>

                                    <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div>
                                                <label>Metric</label>
                                                <MetricFilter ref="metricFilter" onSelectMetric = {this.handleMetric} />
                                            </div>
                                            <div style={{marginTop:'10px'}}>
                                                <label>Amount Notation</label>
                                                <AmountNotationFilter ref="amountNotationFilter" onSelectAmountNotation = {this.handleAmountNotation} />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_dcc_sales_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_export ?
                                        <div className="">
                                            <a href="#" className="exportButton" role="button"
                                               onClick={this.downloadDccSalesMerchantLevelCheck.bind(this, 'merchant', '')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div> : null}

                                    <div className="clearfix"></div>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loadingtable}
                                    />
                                    {this.state.is_record ?
                                        <div
                                            className="content-tdetails-table table-full-width table-responsive marginTop0">
                                            <table id="GpayMonthlySalesReportsCat"
                                                   className="table table-striped table-hover">

                                            </table>
                                        </div> :
                                        <div className="empty_data"> No record Found</div>
                                    }

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_export2 ?
                                        <div className="">
                                            <a href="#" className="exportButton" role="button"
                                               onClick={this.downloadDccSalesMerchantLevel.bind(this, 'store', this.state.store_level_chain_code)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div> : null}
                                    <div id="StoreLabel"
                                         className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="GpayMonthlySalesReportsCatStore"
                                               className="table table-striped table-hover">

                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100"
                                            effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url == '' ?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(GooglePayMonthlySalesReports)